import styled from 'styled-components';
import { Typography, IconButton } from '@mui/material';
import { CloseGrayIcon } from 'shared-ui';

export const RemoveIconWrapper = styled(IconButton)`
  cursor: pointer;
  pointer-events: initial;
  padding: 4px;
  margin: 0;

  &.MuiSelect-icon {
    top: 9px;
  }

  &.MuiSelect-iconOpen {
    top: 10px;
    right: 8px;
  }
`;

export const SelectIconWrapper = styled.div`
  &.MuiSelect-icon {
    top: 12px;
  }

  &.MuiSelect-iconOpen {
    top: 8px;
  }
`;

export const Filters = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(100px, 1fr));
  gap: 16px;
`;

export const ClearFiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 10px;
`;

export const ClearFiltersButton = styled(Typography)`
  display: flex;
  align-items: center;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 400;
  cursor: pointer;
  justify-self: flex-end;
`;

export const ClearFiltersIcon = styled(CloseGrayIcon)`
  margin-left: 10px;
  margin-bottom: 4px;
`;

export const SearchWrapper = styled.div`
  grid-row: 2;
  grid-column: 1;
`;

export const ActionsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  grid-row: 2;
  grid-column: 2 / -1;

  & > *:first-child {
    width: 200px;
    height: 47px;
    margin-bottom: 0;

    & > * {
      width: 100%;
      height: 100%;
    }
  }
`;
